import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/catalogos/cancelaciones-de-recargos/';

/**
 * GET Tipos de Recargos Omitidos
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeRecargosOmitidos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (error) {
    onError(error);
    return [];
  }
};

/**
 * POST Tipos de Recargos Omitidos
 * @param {object} data
 * @returns {Promise<object|boolean>}
 */
export const postTiposDeRecargosOmitidos = async (data) => {
  try {
    const formattedValues = getFormattedValues(data);
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Creado correctamente');
    return formatReceived(response.data);
  } catch (error) {
    onError(error);
    return false;
  }
};

/**
 * PATCH Tipos de Recargos Omitidos
 * @param {number} id
 * @param {object} data
 * @returns {Promise<object|boolean>}
 */
export const patchTiposDeRecargosOmitidos = async (id, data) => {
  try {
    const formattedValues = getFormattedValues(data);
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (error) {
    onError(error);
    return [];
  }
};

/**
 * DELETE Tipos de Recargos Omitidos
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteTiposDeRecargosOmitidos = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (error) {
    onError(error);
    return false;
  }
};
